import icon from './icons8-search-22.png';

const SearchIcon = ({styles}) => {
	return <img src={icon} style={styles}/>
};

export default SearchIcon;